import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LessonState } from 'src/model/Lessons';
import { ScenariosLocation } from 'src/utils/URLUtils';
import styles from './ScenarioItem.module.scss';

interface ScenarioItemProps {
    lesson: LessonState;
}

const ScenarioItem = ({ lesson }: ScenarioItemProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = () => {
        navigate(`/scenario/category?id=${lesson.QuestionId}`);
    };

    return (
        <div className={styles.scenarioItem} onClick={handleClick}>
            <div className={styles.imageContainer}>
                <img src={ScenariosLocation(lesson.QuestionId)} alt={lesson.Name} />
            </div>
            <div className={styles.content}>
                <h3>{t(lesson.Name)}</h3>
                <p>{t(`${lesson.TotalCount} challenges`)}</p>
            </div>
        </div>
    );
};

export default ScenarioItem;
